/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to collect an answer to a choice.
 */
export class SelectIdPCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the available providers.
     */
    getProviders() {
        return this.getOutputByName('providers', []);
    }
    /**
     * Sets the provider by name.
     */
    setProvider(value) {
        const item = this.getProviders().find((item) => item.provider === value);
        if (!item) {
            throw new Error(`"${value}" is not a valid choice`);
        }
        this.setInputValue(item.provider);
    }
}
